import React from "react"
import PropTypes from "prop-types"
import { graphql, Link } from "gatsby"
import Headshot from "components/Headshot"
import theme from "theme"

const SpeakerCard = ({
  name,
  slug,
  position,
  headshot,
  shapeMask,
  variant = "standard",
}) => {
  const width = widths[variant]

  return (
    <Link
      to={slug.current}
      css={{
        maxWidth: 360,
        textDecoration: "none",
        ":hover": { h3: { textDecoration: "underline" } },
      }}
    >
      <Headshot
        {...headshot}
        width={width}
        css={{ width, display: "block", marginBottom: 20 }}
        shape={shapeMask}
      />
      <h3 css={variant === "small" ? theme.hxs : theme.h3}>{name}</h3>
      <div
        css={{
          ...(variant === "small" ? theme.bxs : theme.small),
          marginTop: 4,
        }}
      >
        {position}
      </div>
    </Link>
  )
}

export default SpeakerCard

SpeakerCard.propTypes = {
  name: PropTypes.string.isRequired,
  slug: PropTypes.shape({
    current: PropTypes.string.isRequired,
  }).isRequired,
  position: PropTypes.string.isRequired,
  headshot: PropTypes.shape({
    asset: PropTypes.shape({
      _id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  shapeMask: Headshot.propTypes.shape,
  variant: PropTypes.oneOf(["small", "standard", "large"]),
}

const widths = {
  small: 160,
  standard: 200,
  large: 290,
}

export const query = graphql`
  fragment SpeakerCard on SanityConfigSpeaker {
    _id
    name
    slug {
      current
    }
    position
    headshot {
      ...ImageWithPreview
    }
    shapeMask
  }
`
